// extracted by mini-css-extract-plugin
module.exports = {"root":"az_jEb","positionFixed":"az_kEb","positionAbsolute":"az_lEb","positionSticky":"az_mEb","positionStatic":"az_nEb","positionRelative":"az_oEb"};